import { NUDGES_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface INudgesEscalationTicketProps {
  booking_list: Array<string>;
}

AxiosCurlirize(axios, () => {});

export const useEscalationTicketOnNudgeAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (nudgeBody: INudgesEscalationTicketProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .post(`${NUDGES_APIS?.NUDGES_TELECONSULTATION_ESCALATION_TICKET?.baseURL}`, nudgeBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              return { status: true };
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        captureError(e);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
